import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    brands: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1em',
      '&.store-brands': {
        padding: '25px 0',
      },
      '& .brand': {
        marginTop: 20,
        marginRight: 20,
        '&:last-child': {
          marginRight: 0,
        },
      },
    },
    tooltipCashStoreDetails: {
      maxWidth: 152,
      backgroundColor: ({ primaryColor }) => primaryColor,
      textAlign: 'center',
      '&, & a': {
        fontSize: 12,
      },
      '& a': {
        color: ({ secondaryColor }) => secondaryColor,
      },
    },
    tooltipCashStoreDetailsArrow: {
      '&::before': {
        backgroundColor: ({ primaryColor }) => primaryColor,
      },
    },
    infoIcon: {
      color: ({ secondaryColor }) => secondaryColor,
    },
  }),
);

export default useStyles;
